import Vue from 'vue';
import searchModule from './index.vue';

Vue.component('tg-search-module',searchModule)